<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
            </div>
            <div class="card-body">

                <div class="form-group">
                    <label>Monat</label>
                    <input type="text" class="form-control" v-model="config.month">
                </div>

                <div class="form-group">
                    <label>Jahr</label>
                    <input type="text" class="form-control" v-model="config.year">
                </div>

                <div class="form-group">
                    <label>Apotheken Listen</label>
                    <select class="form-control" v-model="config.pharmaciesLists" multiple>
                        <option :value="list.id" v-for="list in pharmaciesLists">
                            {{ list.title }} ({{ list.config.content.length }})
                        </option>
                    </select>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="force-adas"
                               v-model="config.forceAdasFallback">
                        <label class="form-check-label" for="force-adas">
                            Adas Fallback erzwingen
                        </label>
                    </div>
                </div>

            </div>
        </div>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../../Modules/TimingPeriodModule";
import FilteringModule from "../../Modules/FilteringModule";

export default {
    components: {FilteringModule, TimingPeriodModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
        };
    },
    methods: {},
    computed: {
        pharmaciesLists() {
            return (this.options.lists['pharmacies-wholesalers'] || []);
        },
    }
}
</script>
